import { useState } from "react";
import { toast } from "sonner";
import { FileSpreadsheet, Download } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { api, errMsg } from "@/lib/api";

const Result = ({ res }) => (
  <div className="text-sm space-y-2 border-t pt-4" data-testid="regate-import-result">
    <p><strong data-testid="regate-import-inserted">{res.inserite}</strong> regate importate.</p>
    {res.duplicate.length > 0 && <p className="text-muted-foreground" data-testid="regate-import-duplicates">Già presenti (saltate): righe {res.duplicate.join(", ")}</p>}
    {res.errori.length > 0 && (
      <ul className="text-red-700 space-y-0.5 max-h-40 overflow-y-auto" data-testid="regate-import-errors">
        {res.errori.map((e) => <li key={e.riga}>Riga {e.riga}: {e.errore}</li>)}
      </ul>
    )}
  </div>
);

export const RegateImport = ({ onDone }) => {
  const [file, setFile] = useState(null);
  const [busy, setBusy] = useState(false);
  const [res, setRes] = useState(null);

  const template = async () => {
    const { data } = await api.get("/admin/regate/template.xlsx", { responseType: "blob" });
    const a = document.createElement("a");
    a.href = URL.createObjectURL(data);
    a.download = "modello_calendario_regate.xlsx";
    a.click();
    URL.revokeObjectURL(a.href);
  };

  const upload = async () => {
    if (!file) return toast.error("Seleziona un file .xlsx");
    const fd = new FormData();
    fd.append("file", file);
    setBusy(true);
    try {
      const { data } = await api.post("/admin/regate/import", fd);
      setRes(data);
      toast.success(`${data.inserite} regate importate`);
      onDone();
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog onOpenChange={(o) => { if (!o) { setRes(null); setFile(null); } }}>
      <DialogTrigger asChild>
        <Button variant="outline" className="rounded-full bg-white" data-testid="regate-import-button"><FileSpreadsheet className="h-4 w-4 mr-1" />Importa Excel</Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-lg" data-testid="regate-import-dialog">
        <DialogHeader><DialogTitle className="font-heading text-2xl uppercase">Importa calendario regate</DialogTitle></DialogHeader>
        <p className="text-sm text-muted-foreground">
          Colonne: Data inizio, Data fine, Tipo (Zonale, Nazionale, Internazionale), Denominazione, Numero circolo, Nome circolo, Città,
          Categoria barca (una o più separate da virgola). Facoltativa: Termine iscrizioni. Se il numero circolo è già in archivio viene usato il nome presente in archivio.
        </p>
        <Button variant="link" className="px-0 w-fit text-emerald-700" onClick={template} data-testid="regate-import-template-button"><Download className="h-4 w-4 mr-1" />Scarica il modello Excel</Button>
        <Input type="file" accept=".xlsx" onChange={(e) => setFile(e.target.files?.[0] || null)} data-testid="regate-import-file-input" />
        <Button onClick={upload} disabled={busy} className="bg-emerald-600 hover:bg-emerald-700" data-testid="regate-import-submit-button">{busy ? "Importazione…" : "Importa"}</Button>
        {res && <Result res={res} />}
      </DialogContent>
    </Dialog>
  );
};
